import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Switch } from '@/components/ui/switch';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Swords, Info } from 'lucide-react';
import { useState } from 'react';
import { useToast } from '@/hooks/use-toast';

export const DebateSettings = () => {
  const [enabled, setEnabled] = useState(true);
  const [maxArgumentsPerSide, setMaxArgumentsPerSide] = useState(3);
  const [allowAnonymous, setAllowAnonymous] = useState(true);
  const [autoEvaluate, setAutoEvaluate] = useState(true);
  const { toast } = useToast();

  const handleSave = () => {
    // In a real implementation, this would save to database
    toast({
      title: 'Innstillinger lagret',
      description: 'deBattle-innstillingene er oppdatert.',
    });
  };

  return (
    <Card>
      <CardHeader>
        <div className="flex items-center gap-2">
          <Swords className="w-5 h-5 text-primary" />
          <CardTitle>deBattle</CardTitle>
        </div>
        <CardDescription>
          Administrer debatt- og argumentasjonsfunksjoner
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">
        {/* Main toggle */}
        <div className="flex items-center justify-between">
          <Label htmlFor="debate-enabled">deBattle aktivert</Label>
          <Switch
            id="debate-enabled"
            checked={enabled}
            onCheckedChange={setEnabled}
          />
        </div>

        {enabled && (
          <>
            {/* Debate format info */}
            <div className="p-3 bg-muted rounded-lg">
              <div className="flex items-start gap-2">
                <Info className="w-4 h-4 mt-0.5 text-muted-foreground" />
                <div className="text-sm">
                  <p className="font-medium mb-1">Debattformat</p>
                  <p className="text-muted-foreground">
                    Strukturert 1-mot-1 debatt der to deltakere bytter på å legge frem argumenter.
                    Etter at begge har lagt frem {maxArgumentsPerSide} argumenter hver, 
                    evaluerer Kai (AI) argumentene og kårer en vinner.
                  </p>
                </div>
              </div>
            </div>

            {/* Arguments per side */}
            <div className="space-y-2">
              <Label htmlFor="max-arguments">Maks argumenter per deltaker</Label>
              <Input
                id="max-arguments"
                type="number"
                min={1}
                max={10}
                value={maxArgumentsPerSide}
                onChange={(e) => setMaxArgumentsPerSide(parseInt(e.target.value) || 3)}
                className="w-24"
              />
              <p className="text-xs text-muted-foreground">
                Antall argumenter hver deltaker kan legge frem (standard: 3)
              </p>
            </div>

            {/* Anonymous participation */}
            <div className="flex items-center justify-between">
              <div className="space-y-0.5">
                <Label htmlFor="allow-anonymous">Tillat anonym deltakelse</Label>
                <p className="text-xs text-muted-foreground">
                  La brukere delta i debatter uten å logge inn
                </p>
              </div>
              <Switch
                id="allow-anonymous"
                checked={allowAnonymous}
                onCheckedChange={setAllowAnonymous}
              />
            </div>

            {/* Auto-evaluate */}
            <div className="flex items-center justify-between">
              <div className="space-y-0.5">
                <Label htmlFor="auto-evaluate">Automatisk AI-evaluering</Label>
                <p className="text-xs text-muted-foreground">
                  Kai evaluerer automatisk når alle argumenter er levert
                </p>
              </div>
              <Switch
                id="auto-evaluate"
                checked={autoEvaluate}
                onCheckedChange={setAutoEvaluate}
              />
            </div>

            {/* Scoreboard info */}
            <div className="space-y-2">
              <Label>Scoreboard</Label>
              <p className="text-sm text-muted-foreground">
                Vinnere registreres automatisk i scoreboardet på /debatter. 
                Kun innloggede brukere får poeng.
              </p>
            </div>
          </>
        )}

        <div className="pt-4 border-t">
          <Button onClick={handleSave}>Lagre innstillinger</Button>
        </div>
      </CardContent>
    </Card>
  );
};